
import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';

const JOB_CATEGORIES = [
  "Sales",
  "Marketing", 
  "Engineering",
  "Support",
  "HR",
  "Finance",
  "Other"
];

interface JobCategoryFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
}

const JobCategoryField = ({
  id,
  label,
  value,
  onChange
}: JobCategoryFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor={id} className="text-redflags-dark">
        {label}
      </Label>
      
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger id={id} className="w-full">
          <SelectValue placeholder="Select job category" />
        </SelectTrigger>
        <SelectContent>
          {JOB_CATEGORIES.map((category) => (
            <SelectItem key={category} value={category}>
              {category}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default JobCategoryField;
